<template>
  <div class="level has-text-left header-label">
    <div class="level-left icons-margin p-5 mr-10">
      <span class="mx-10 has-text-color-7 is-align-self-center">
        {{ General.PARTICIPATE }}:
      </span>
      <ShareNetwork
        network="facebook"
        :url="url"
        :title="title"
        :description="description"
        hashtags="GovCe, GovBr, Suite"
      >
        <b-icon
          icon="facebook"
          class="is-clickable"
          :type="isContrast ? 'is-white' : 'is-blue-oil'"
        />
      </ShareNetwork>
      <ShareNetwork
        network="Twitter"
        :url="url"
        :title="title"
        hashtags="GovCe, GovBr, Suite"
      >
        <b-icon
          icon="twitter"
          class="is-clickable"
          :type="isContrast ? 'is-white' : 'is-blue-oil'"
        />
      </ShareNetwork>
      <ShareNetwork
        network="WhatsApp"
        :url="url"
        :title="title"
        hashtags="GovCe, GovBr, Suite"
      >
        <b-icon
          icon="whatsapp"
          class="is-clickable"
          :type="isContrast ? 'is-white' : 'is-blue-oil'"
        />
      </ShareNetwork>
      <a v-clipboard:copy="url" v-clipboard:success="handleCopyStatus">
        <b-icon
          icon="link-variant"
          class="is-clickable"
          :type="isContrast ? 'is-white' : 'is-blue-oil'"
        />
      </a>
      <span class="is-size-5 has-text-weight-normal mx-10 has-text-color-7"
        >|</span
      >
      <b-icon
        icon="printer"
        class="is-clickable"
        :type="isContrast ? 'is-white' : 'is-blue-oil'"
        @click.native="printScreen"
      />
    </div>
  </div>
</template>

<script>
import { General } from "@/utils/constants";
import { mapGetters } from "vuex";

export default {
  name: "MediaShareBar",
  props: {
    url: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ""
    },
    printId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      General
    };
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast",
      isMobile: "isMobile"
    })
  },

  methods: {
    printScreen() {
      const printableHtml = document.getElementById(this.printId).innerHTML;

      let printableStyles = "";
      [...document.querySelectorAll("link[rel='stylesheet'], style")].forEach(
        element => {
          printableStyles += element.outerHTML;
        }
      );
      const printableWindow = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      printableWindow.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${printableStyles}
        </head>
        <body>
          ${printableHtml}
        </body>
      </html>`);

      printableWindow.document.close();
      printableWindow.focus();
      printableWindow.print();
    },

    handleCopyStatus() {
      this.$buefy.toast.open({
        message: General.COPIED_URL,
        type: "is-green-dark"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";
.header-label {
  margin-top: 10px;
  margin-left: 30px;
  margin-right: 30px;
  background-color: var(--app-background-color);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-radius: 5px !important;

  @media screen and (max-width: $tablet) {
    margin: 10px 15px 20px;
  }
}
</style>
